import { apiFetch } from './api';

/**
 * List all support tickets (admin)
 */
export function getSupportTickets(params = {}) {
  const query = new URLSearchParams();
  if (params.status) query.append('status', params.status);
  if (params.page) query.append('page', params.page);
  if (params.limit) query.append('limit', params.limit);
  const qs = query.toString();
  return apiFetch(`/api/admin/support-tickets${qs ? `?${qs}` : ''}`);
}

/**
 * Get a single support ticket with replies (admin)
 */
export function getSupportTicket(ticketId) {
  return apiFetch(`/api/admin/support-tickets/${ticketId}`);
}

/**
 * Send a reply to a support ticket (admin)
 */
export function sendSupportTicketReply(ticketId, payload) {
  return apiFetch(`/api/admin/support-tickets/${ticketId}/replies`, {
    method: 'POST',
    body: payload
  });
}

/**
 * Update support ticket status (admin)
 */
export function updateSupportTicketStatus(ticketId, status) {
  return apiFetch(`/api/admin/support-tickets/${ticketId}`, {
    method: 'PATCH',
    body: { status }
  });
}

/**
 * Unread support tickets (customer activity not yet viewed by admin)
 */
export function getSupportTicketUnreadCount() {
  return apiFetch('/api/admin/support-tickets/unread-count');
}
